import React from 'react';

function Home() {
  return (
    <section className="page home-page">
      <p className="eyebrow">Hello, I am</p>
      <h1>Prapti Setty</h1>
      <p className="lead">
        I design and build.
      </p>
    </section>
  );
}

export default Home;
